import { useRef } from 'react';

export default function CopyToClipboard({ text, onClose }: { text: string; onClose: () => void }) {
  const ref = useRef<HTMLInputElement>(null);

  function handleClick() {
    if (!ref.current) return;
    ref.current.select();
    document.execCommand('copy');
    if (onClose) onClose();
  }

  return (
    <div className="menu-download-container">
      <form onSubmit={e => e.preventDefault()}>
        <input type="text" ref={ref} value={text} readOnly />
        <input type="submit" value="Copy" onClick={handleClick} className="btn" style={{ width: '100%' }} />
      </form>
    </div>
  );
}
